export function authHeader(contentType = 'application/json') {
  // return authorization header with jwt token
  let user = JSON.parse(window.sessionStorage.getItem('disserto_user'));

  if (user && user.token) {
    return [
      ['Authorization', 'Bearer ' + user.token],
      ['Content-Type', contentType],
      ['Cache-control', 'no-cache'],
    ];
  } else {
    return {};
  }
}

export function authHeaderNoContentType() {
  // return authorization header with jwt token
  let user = JSON.parse(window.sessionStorage.getItem('disserto_user'));

  if (user && user.token) {
    return [
      ['Authorization', 'Bearer ' + user.token],
      ['Cache-control', 'no-cache'],
    ];
  } else {
    return {};
  }
}



// WEBPACK FOOTER //
// ./src/utils/auth-header.js